
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Text } from 'office-ui-fabric-react';

const classNames = mergeStyleSets({
    heading: {
        borderBottom: '1px solid #000000'
    },

    sumBox: {
        background: '#F4F4F4',
        padding: '1em'
    },

    summaryInfoBox: {
        paddingBottom: '1em'
    },

    infoLine: {
        display: 'flex',
        justifyContent: 'space-between'
    },

    val: {
        minWidth: '200px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: '0.5em'
    },

    label: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start'
    },

    cont1: {
        backgroundColor: '#F4F4F4',
        padding: '0.2em'
    },

    cont2: {
        backgroundColor: '#ffffff',
        padding: '0.2em'
    }
})

const Summary = ({
    operationItems,
    price
}) => {
    let n = -1;

    return (
        <Stack>
            <Stack.Item className={classNames.summaryInfoBox}>
                {operationItems.map(item => {
                    n = (n+1) % 2;
                    let cont;
                    if (n === 0) {
                        cont = classNames.cont1;
                    } else {
                        cont = classNames.cont2;
                    }

                    let unit;
                    if (item.mj === 'm2') {
                        unit = 'm²';
                    } else {
                        unit = 'm³'
                    }

                    return (
                        <Stack className={cont} horizontal tokens={{childrenGap: 5}} key={item.id}>
                            <Stack.Item grow>{item.title}</Stack.Item>
                            <Stack.Item className={classNames.val}>
                                {new Intl.NumberFormat('cs-CZ').format(item.quantity)} {unit}
                            </Stack.Item>
                            <Stack.Item className={classNames.val}>
                                {new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(item.quantity * item.price)}
                            </Stack.Item>
                        </Stack>
                    );
                })}
            </Stack.Item>
            <Stack.Item className={classNames.sumBox}>
                <Text variant={'mediumB'}>
                    Celkem cena: {new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(price)}
                </Text>
            </Stack.Item>
        </Stack>
    );
}

export default Summary;
